<div mat-dialog-title>
    CHANGE PASSWORD
    <div class="pull-right close" (click)="close()"> &#10005; </div>
</div>
<div mat-dialog-content class="form-fields-theme change-password">
    <form name="changePasswordForm" [formGroup]="changePasswordForm"
        (ngSubmit)="updatePassword(changePasswordForm.value)">
        <mat-form-field>
            <mat-label>Old Password</mat-label>
            <input matInput formControlName="old_password" type="password">
            @if (changePasswordForm.get('old_password').hasError('required')) {
                <mat-error>
                    Old Password is <strong>required</strong>
                </mat-error>
            }
            @if (changePasswordForm.get('old_password').hasError('minlength')) {
                <mat-error>
                    Old Password is too short <i>(minimum is 6 characters)</i>
                </mat-error>
            }
            <div class="space-5"></div>
        </mat-form-field>
        <mat-form-field>
            <mat-label>New Password</mat-label>
            <input matInput formControlName="password" type="password">
            @if (changePasswordForm.get('password').hasError('required')) {
            <mat-error>
                New Password is <strong>required</strong>
            </mat-error>
            }
            @if (changePasswordForm.get('password').hasError('minlength')) {
                <mat-error>
                    New Password is too short <i>(minimum is 6 characters)</i>
                </mat-error>
            }
            <div class="space-5"></div>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Confirm Password</mat-label>
            <input matInput formControlName="password_confirmation" type="password">
            @if (changePasswordForm.get('password_confirmation').hasError('required')) {
                <mat-error>
                    Confirm Password is <strong>required</strong>
                </mat-error>
            }
            @if (changePasswordForm.get('password_confirmation').hasError('passwordMismatch') &&
            changePasswordForm.get('password_confirmation').touched) {
                <mat-error>
                    Passwords do not match
                </mat-error>
            }
        </mat-form-field>
        <div class="space-20"></div>

        <div class="row">
            <div class="col-sm-12">
                <button btn-secondary size="full" [isLoading]="updatingPassword" [disabled]="!changePasswordForm.valid"
                    (click)="updatePassword(changePasswordForm.value)">
                    SUBMIT
                </button>
            </div>
        </div>
    </form>
</div>